import { PolygonRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathPickerContribution, MathPolygonPicker } from "../constants";

import { DefaultMathPolygonPicker } from "./polygon-picker";

let loadPolygonPick = !1;

export function bindPolygonMathPickerContribution(container) {
    loadPolygonPick || (loadPolygonPick = !0, container.bind(MathPolygonPicker).toDynamicValue((() => new DefaultMathPolygonPicker(resolveContainerBinding(container, PolygonRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathPolygonPicker));
}
//# sourceMappingURL=polygon-module.js.map
